import { useDispatch } from 'react-redux'
import { useMutation } from '@tanstack/react-query'
import { deleteConceptConfiguration } from '../state/actions'

export const useDeleteConceptConfiguration = () => {
  const dispatch = useDispatch()

  return useMutation(async (uuid: string) => {
    return dispatch(deleteConceptConfiguration(uuid))
  })
}
